import { produce } from 'immer';
import _, { Dictionary } from 'lodash';
import { combineReducers } from 'redux';
import { conf, RelType, RelSide, Relationship } from 'src/config';
import * as constants from './constants';
import * as types from './types';

export const initialState: types.NetworkLog = {
    log: []
}

const networkLogReducer = (
    state = _.cloneDeep(initialState),
    action: types.Actions
) => {
    return produce(state, draft => {
        /* --------------------------------------------------------------------------------------------------- */
        if (action.type === constants.CLEAR) {
            draft.log = [];
        } else if (action.type === constants.ADD_LOG_ENTRY) {
            draft.log.push(action.entry);

        }
    });
};

export default networkLogReducer;
